import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await login(email, password);
    setLoading(false);
    if (result.success) {
      navigate('/');
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="min-h-screen flex" data-testid="login-page">
      {/* Left: Form */}
      <div className="flex-1 flex items-center justify-center p-8 bg-white">
        <div className="w-full max-w-sm space-y-8">
          <div className="flex items-center gap-3 mb-2">
            <img src="https://customer-assets.emergentagent.com/job_campaign-tracker-97/artifacts/ozya3vdh_final%20logo-01-01.jpg" alt="CampREV" className="h-12 w-12 object-contain" />
            <span className="text-2xl font-black tracking-tighter text-zinc-950">CampREV</span>
          </div>
          <div>
            <h1 className="text-4xl sm:text-5xl font-black tracking-tighter text-zinc-950">
              Sign In
            </h1>
            <p className="mt-2 text-sm text-zinc-500">
              Access your campaign dashboard
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 text-sm p-3 rounded-sm" data-testid="login-error">
                {error}
              </div>
            )}

            <div className="space-y-2">
              <Label htmlFor="email" className="text-xs font-medium tracking-[0.1em] uppercase text-zinc-500">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@example.com"
                className="rounded-none border-zinc-300 focus:border-black focus:ring-black"
                data-testid="login-email-input"
                required
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password" className="text-xs font-medium tracking-[0.1em] uppercase text-zinc-500">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                className="rounded-none border-zinc-300 focus:border-black focus:ring-black"
                data-testid="login-password-input"
                required
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full rounded-none bg-black text-white hover:bg-zinc-800 transition-all duration-150"
              data-testid="login-submit-button"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
          </form>

          <div className="text-sm text-zinc-500">
            <Link to="/forgot-password" className="block hover:text-black transition-colors" data-testid="forgot-password-link">
              Forgot password?
            </Link>
          </div>
        </div>
      </div>

      {/* Right: Image */}
      <div className="hidden lg:block flex-1 relative">
        <img
          src="https://images.unsplash.com/photo-1763303775599-08d20753a9ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGFyY2hpdGVjdHVyYWwlMjBnZW9tZXRyeSUyMHdoaXRlfGVufDB8fHx8MTc3NTQ3MzQyMXww&ixlib=rb-4.1.0&q=85"
          alt="Abstract"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/10" />
      </div>
    </div>
  );
}
